import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: 'AIzaSyBjM5j6hGKqOyVZ3J0TXhqTAwakHAtpt1c',
  authDomain: 'jobscapsule.firebaseapp.com',
  projectId: 'jobscapsule',
  storageBucket: 'jobscapsule.firebasestorage.app',
  messagingSenderId: '646737464311',
  appId: '1:646737464311:web:095cdfad66eace933e3cf2',
  measurementId: 'G-68L9DR59T1',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
  // <React.StrictMode>
  //   <App />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
